// OfferingsSection.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import './OfferingsSection.css';

const OfferingsSection = () => {
  const { api } = useAuth();

  const [offerings, setOfferings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = sessionStorage.getItem('offerings');
    if (cached) {
      const data = JSON.parse(cached).filter(item => item.name !== 'CustomAdRequest');
      setOfferings(data);               // ← [2] load cached
    } else {
      setLoading(true);
      api.get('/api/searchItems', { params: { limit: 12 } })
        .then(res => {
          const data = res.data.items.filter(item => item.name !== 'CustomAdRequest');
          sessionStorage.setItem('offerings', JSON.stringify(data)); // ← cache raw
          setOfferings(data);                                      // ← set from API
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching offerings:', err);
          setLoading(false);
        });
    }
  }, [api]);

  if (loading) return <p>Loading...</p>;

  // ← [3] show only first 8 items (assumes 4 per row × 2 rows)
  const visibleOfferings = offerings.slice(0, 8);

  return (
    <div className="offerings-section">
      <h2>iMR Approved Promotional Items</h2>
      <p>
        iMR Approved Ad Templates <a href="/ad-templates">here</a>
      </p>
      <div className="offerings-grid">
        {visibleOfferings.map(offering => (
          <Link
            key={offering.id}                             // use stable key
            to={`/product/${offering.id}/template`}
            className="offering-item"
          >
            <img
              src={offering.image}
              alt={offering.name}
              className="offering-image"
            />
            <p>{offering.name}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OfferingsSection;
